export default __webpack_public_path__ + "68740d3c81e4324d0c10b935f4f5caeb.png";